import { styled } from "@mui/material";

export const SearchFilterCompanyContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: "10px",
  marginBottom: "10px",
}));
